import { useState } from 'react'
import InfoModal from '../ui/InfoModal'
import { termsContent, privacyContent } from '../../lib/constants/legalContent'
import './Footer.css'

export default function Footer() {
    const currentYear = new Date().getFullYear()
    const [modalConfig, setModalConfig] = useState<{ isOpen: boolean; title: string; content: React.ReactNode }>({
        isOpen: false,
        title: '',
        content: null
    })

    const openModal = (title: string, content: React.ReactNode) => {
        setModalConfig({ isOpen: true, title, content })
    }

    const closeModal = () => {
        setModalConfig(prev => ({ ...prev, isOpen: false }))
    }

    const socialLinks = [
        {
            name: 'Twitter',
            url: 'https://twitter.com/ghost_flash_usdt',
            icon: <svg viewBox="0 0 24 24" width="20" height="20" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round"><path d="M4 4l11.733 16h4.267l-11.733 -16z" /><path d="M4 20l6.768 -6.768m2.46 -2.46l6.772 -6.772" /></svg>
        },
        {
            name: 'TikTok',
            url: 'https://tiktok.com/@ghost_flash_usdt',
            icon: <svg viewBox="0 0 24 24" width="20" height="20" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round"><path d="M9 12a4 4 0 1 0 4 4v-12a5 5 0 0 0 5 5" /></svg>
        },
        {
            name: 'Telegram',
            url: 'https://t.me/tetherstreaam',
            icon: <svg viewBox="0 0 24 24" width="20" height="20" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round"><path d="M15 10l-4 4l6 6l4 -16l-18 7l4 2l2 6l3 -4" /></svg>
        },
        {
            name: 'WhatsApp',
            url: 'https://wa.me/message/ZDTUK76LA35BN1',
            icon: <svg viewBox="0 0 24 24" width="20" height="20" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round"><path d="M3 21l1.65 -3.8a9 9 0 1 1 3.4 2.9l-5.05 .9" /><path d="M9 10a0.5 .5 0 0 0 1 0v-1a0.5 .5 0 0 0 -1 0v1a5 5 0 0 0 5 5h1a0.5 .5 0 0 0 0 -1h-1a0.5 .5 0 0 0 0 1" /></svg>
        },
        {
            name: 'Instagram',
            url: 'https://instagram.com/ghost_flash_usdt',
            icon: <svg viewBox="0 0 24 24" width="20" height="20" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="2" width="20" height="20" rx="5" ry="5" /><path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" /><line x1="17.5" y1="6.5" x2="17.51" y2="6.5" /></svg>
        }
    ]

    return (
        <>
            <footer className="footer">
                <div className="container">
                    <div className="footer-content">
                        <div className="footer-brand">
                            <div className="footer-logo">
                                <span className="text-white">TetherStream Protocol</span>
                                <span className="text-neon"></span>
                            </div>
                            <p className="footer-desc">
                                Enterprise-grade USDT settlement infrastructure.
                                Atomic. Cryptographic. Non-Custodial.
                            </p>
                        </div>

                        <div className="footer-links">
                            <h4 className="footer-heading">Quick Links</h4>
                            <nav className="footer-nav">
                                <a href="#about" className="footer-link">About</a>
                                <a href="#faq" className="footer-link">Support</a>
                                <button className="footer-link btn-text" onClick={() => openModal('Terms of Service', termsContent)}>Terms</button>
                                <button className="footer-link btn-text" onClick={() => openModal('Privacy Policy', privacyContent)}>Privacy</button>
                            </nav>
                        </div>

                        <div className="footer-social">
                            <h4 className="footer-heading">Connect</h4>
                            <div className="social-links">
                                {socialLinks.map((social, index) => (
                                    <a
                                        key={index}
                                        href={social.url}
                                        className="social-link animate-glitch"
                                        aria-label={social.name}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        {social.icon}
                                    </a>
                                ))}
                            </div>
                        </div>
                    </div>

                    <div className="footer-bottom">
                        <div className="footer-divider"></div>

                        <div className="footer-compliance">
                            <h4 className="footer-heading">Compliance & Risk Management</h4>
                            <p className="compliance-text">
                                TetherStream Protocol operates as non-custodial settlement infrastructure.
                                Users maintain full control of private keys and assets. All transactions are
                                cryptographically verified and recorded on-chain. Security audits conducted
                                quarterly by independent third parties.
                            </p>
                        </div>

                        <p className="footer-copyright">
                            © {currentYear} TetherStream Protocol. All rights reserved.
                        </p>
                        <p className="footer-warning">
                            <span className="text-neon">⚠</span> Financial services disclaimer: Cryptocurrency transactions carry inherent risks.
                            Users should conduct independent research and understand the risks before engaging with settlement protocols.
                        </p>
                    </div>
                </div>
            </footer>

            <InfoModal
                isOpen={modalConfig.isOpen}
                onClose={closeModal}
                title={modalConfig.title}
                content={modalConfig.content}
            />
        </>
    )
}
